// 공통 상수 정의
export const POINT_UNIT = '자두'

// 토큰 매칭 관련 상수
export const TOKEN_MATCHING = {
  SIMILARITY_THRESHOLD: 0.8, // 토큰 유사도 임계값 (95%) - 더 엄격한 매칭
  USE_SIMILARITY: true, // 유사도 모드 사용 여부
} as const

// 지문 제한 관련 상수
export const PASSAGE_LIMIT = {
  //MAX_PASSAGES: 15, // 최대 지문 개수
  MAX_PASSAGES: import.meta.env.VITE_MAX_PASSAGES, // 최대 지문 개수
  ERROR_MESSAGE: `최대 ${import.meta.env.VITE_MAX_PASSAGES}개의 지문만 등록 가능합니다.`,
} as const

// 텍스트 매칭 유사도 및 신뢰도 관련 상수
export const ULTRA_PRINT_MATCHING = {
  // === 최종 매칭 성공 임계값 ===
  FINAL_MATCH_THRESHOLD: 0.6, // 최종 유사도 매칭 성공 임계값 (90% 이상일 때 매칭 성공으로 판단)

  // === 각 레벨별 신뢰도 값 ===
  PUNCTUATION_CONFIDENCE: 0.6, // Level 2: 구두점 정규화 매칭 시 신뢰도
  SPACE_VARIANT_CONFIDENCE: 0.6, // Level 3: 공백 변형 매칭 시 신뢰도
  NOISE_REMOVAL_CONFIDENCE: 0.6, // Level 4: 노이즈 제거 매칭 시 신뢰도

  // === 신뢰도 계산 관련 ===
  CONFIDENCE_MULTIPLIER: 0.6, // 유사도 점수를 confidence로 변환 시 사용하는 승수

  // === 중간 임계값 ===
  MEDIUM_MATCH_THRESHOLD: 0.6, // 중간 수준 매칭 임계값 (85% 이상일 때 부분 매칭 성공)

  // === 기존 토큰 매칭 임계값 (참조용) ===
  // TOKEN_MATCHING.SIMILARITY_THRESHOLD: 0.8 - 이미 정의됨
} as const

/**
 * WorkerPool 관련 전역 설정 상수
 */
export const WORKER_POOL_CONFIG = {
  // 청크 크기 (각 워커가 처리할 문제 개수)
  CHUNK_SIZE: 60,

  // 워커 풀 설정
  MAX_WORKERS: 8,
  MIN_WORKERS: 2,
  WORKER_TIMEOUT: 30000, // 30초

  // 메트릭 및 로깅
  ENABLE_METRICS: true,
} as const

/**
 * WorkerPool 관련 로그 메시지
 */
export const WORKER_POOL_MESSAGES = {
  PARALLEL_PROCESSING_START: '병렬 처리 시작',
  PROCESSING_COMPLETE: '병렬처리 완료',
  CHUNK_PROCESSING_COMPLETE: '청크 처리 완료',
} as const

/**
 * 성능 최적화 관련 설정
 */
export const PERFORMANCE_CONFIG = {
  // 최대 병렬 청크 수 (CPU 코어 수 기반)
  MAX_PARALLEL_CHUNKS: 8,

  // 청크 분배 전략
  DISTRIBUTION_STRATEGY: 'round_robin' as const, // 'sequential' | 'round_robin'

  // 복잡도 기반 로드밸런싱 활성화
  ENABLE_COMPLEXITY_BALANCING: true,
} as const

// TypeScript에서 readonly 타입으로 추론하기 위한 타입 정의
export type WorkerPoolConfig = typeof WORKER_POOL_CONFIG
export type WorkerPoolMessages = typeof WORKER_POOL_MESSAGES
export type PerformanceConfig = typeof PERFORMANCE_CONFIG
